import { useAuthAppStore } from "@/store/stores/authStore";

/**
 * Budget Tracking service. CRUD load/insert/update/remove go through the shared
 * devExtremeCrudService against cproxServiceClient.finance + the /budget/* routes
 * (mirrors CostCentre). This service adds Excel export/import and the balance read
 * used by the PR header.
 */
export class BudgetTrackingService {

  async setExport(filters, cproxServiceClient) {
    try {
      const response = await cproxServiceClient.finance.post({
        data: {
          Filters: filters,
        },
        route: "/budget/download-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });

      if (response && response.status) {
        return response;
      }
      throw new Error("Invalid response from BudgetTrackingService.setExport");
    } catch (error) {
      console.error("budget/download-entities failed", error);
      throw error;
    }
  }

  async setImport(file, deleteNotInFile, cproxServiceClient, fileManagerService) {
    try {
      const convertedFile = await fileManagerService.convertToByteArray(file);

      const response = await cproxServiceClient.finance.post({
        data: {
          File: JSON.stringify(Array.from(convertedFile)),
          DeleteNotInFile: deleteNotInFile,
        },
        route: "/budget/import-entities",
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          "Content-Type": "application/json",
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });

      if (response && response.status) {
        return response;
      }
      throw new Error("Invalid response from BudgetTrackingService.setImport");
    } catch (error) {
      console.error("budget/import-entities failed", error);
      throw error;
    }
  }

  /**
   * Returns all budgets defined for the current complex (X-YPH-COMPLEX). The caller filters
   * by fiscal year / Active status. Used to populate the Project Number dropdown on the PR
   * header in budget-tracking complexes (so users can only pick a defined project code).
   */
  async getBudgets({ cproxServiceClient }) {
    return await cproxServiceClient.finance.get({
      route: "/budget/get-all-entities",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
    });
  }

  /**
   * Reads the Active budget balance for a project code + fiscal year, optionally projected
   * into a target currency. Used by the PR header balance panel.
   */
  async getBudgetBalance({ cproxServiceClient, code, fiscalYear, targetCurrencyCode }) {
    const response = await cproxServiceClient.finance.get({
      route: "/budget/get-balance",
      params: {
        Code: code,
        FiscalYear: fiscalYear,
        TargetCurrencyCode: targetCurrencyCode,
      },
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
    });

    return response;
  }
}
